import { Cursor as CursorCore } from '@studiometa/ui';

/**
 * Cursor component
 */
export default class Cursor extends CursorCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Cursor',
    options: {
      ...CursorCore.config.options,
      relative: {
        type: Boolean,
        default: false,
      },
    },
  };

  offsetX = 0;

  offsetY = 0;

  size = [];

  /**
   * @type {boolean}
   */
  isDrag = false;

  /**
   * Mounted hook.
   * @returns {void}
   */
  mounted() {
    super.mounted();

    if (this.$options.relative) {
      this.size = this.$parent.$el.getBoundingClientRect();
    } else {
      this.$services.disable('scrolled');
    }

    window.addEventListener('mousedown', this.handleMousedown.bind(this), true);
    window.addEventListener('drag', this.handleDrag.bind(this));
    window.addEventListener('dragend', this.handleDragend.bind(this));
  }

  /**
   * Destroyed hook
   * @returns {void}
   */
  destroyed() {
    window.removeEventListener('mousedown', this.handleMousedown);
    window.removeEventListener('drag', this.handleDrag);
    window.removeEventListener('dragend', this.handleDragend);
  }

  /**
   * Handle mouse down
   */
  handleMousedown() {
    this.isDrag = false;
  }

  /**
   * Handle drag
   */
  handleDrag() {
    this.isDrag = true;
  }

  /**
   * Handle drag end
   * @param {DragEvent} event
   */
  handleDragend(event) {
    super.moved({ event, x: event.screenX, y: event.screenY, isDown: false });
  }

  /**
   * Scrolled hook.
   * @returns {void}
   */
  scrolled() {
    if (!this.$options.relative) {
      return;
    }
    this.size = this.$parent.$el.getBoundingClientRect();
  }

  /**
   * Moved hook.
   * @this {CursorInterface}
   * @param {PointerServiceProps} options
   * @returns {void}
   */
  moved({ event, x, y, isDown }) {
    if (!this.$services.has('ticked')) {
      this.$services.enable('ticked');
    }

    if (this.$options.relative) {
      // @todo find a way to prevent reupdating this constently
      this.size = this.$parent.$el.getBoundingClientRect();
      this.pointerX = x - this.size.x + this.offsetX;
      this.pointerY = y - this.size.y + this.offsetY;
    } else {
      this.pointerX = x + this.offsetX;
      this.pointerY = y + this.offsetY;
    }

    let scale = 1;

    if (!event) {
      this.pointerScale = scale;
      return;
    }

    const shouldGrow =
      (event.target instanceof Element && event.target.matches(this.$options.growSelectors)) ||
      false;
    const shouldReduce =
      (isDown && !this.isDrag) ||
      (event.target instanceof Element && event.target.matches(this.$options.shrinkSelectors)) ||
      false;

    if (shouldGrow) {
      scale = this.$options.growTo;
    }

    if (shouldReduce) {
      scale = this.$options.shrinkTo;
    }

    this.pointerScale = scale;
  }
}
